import React from "react";
import {
  Datagrid,
  DateField,
  ShowButton,
  ReferenceManyField,
  Show,
  Tab,
  TabbedShowLayout,
  TextField,
  NumberField,
  BooleanField,
  EditButton,
} from "react-admin";
import AddCultureButton from "./AddCultureButton";
import AddIsolatesButton from "../isolates/AddIsolatesButton";

const SamplesShow = (props) => (
  <Show {...props}>
    <TabbedShowLayout>
      <Tab label="Sample">
        <TextField source="code" />
        <TextField source="sample" />

        <DateField source="collection_date" />
        <TextField source="description" />
        <NumberField source="longitude" />
        <NumberField source="latitude" />
        <TextField source="source" />
        <TextField source="sampling_site" />
        <NumberField source="id_catalog_sample" />
        <NumberField source="id_storage" />
        <NumberField source="id_provider" />
      </Tab>
      <Tab label="Cultures" path="cultures">
        <ReferenceManyField
          addLabel={false}
          reference="cultures"
          target="id_sample"
          sort={{ field: "updatedAt", order: "DESC" }}
        >
          <Datagrid>
            <TextField source="code" />
            <TextField source="culture" />
            <DateField
              source="culture_date"
              locales="es-UY"
              options={{ timeZone: "UTC" }}
            />
            <TextField source="atmosphere" />
            <NumberField source="num_isolates" />
            <NumberField source="temperature" />
            <TextField source="time_culture" />
            <DateField
              source="createdAt"
              locales="es-UY"
              options={{ timeZone: "UTC" }}
              showTime
            />
            <DateField
              source="updatedAt"
              locales="es-UY"
              options={{ timeZone: "UTC" }}
              showTime
            />
            <EditButton />
            <ShowButton />
          </Datagrid>
        </ReferenceManyField>
        <AddCultureButton />
      </Tab>
      <Tab label="Isolates" path="isolates">
        <ReferenceManyField
          addLabel={false}
          reference="isolates"
          target="id_sample"
          sort={{ field: "updatedAt", order: "DESC" }}
        >
          <Datagrid>
            <TextField source="isolate" />
            <TextField source="code" />
            <BooleanField source="is_isolated" />
            <BooleanField source="has_sequence" />
            <BooleanField source="has_picture" />
            <DateField
              source="createdAt"
              locales="es-UY"
              options={{ timeZone: "UTC" }}
              showTime
            />
            <DateField
              source="updatedAt"
              locales="es-UY"
              options={{ timeZone: "UTC" }}
              showTime
            />
            <EditButton />
            <ShowButton />
          </Datagrid>
        </ReferenceManyField>
        <AddIsolatesButton />
      </Tab>
    </TabbedShowLayout>
  </Show>
);

export default SamplesShow;
